@if (!showAboutMe) {
<p-panel header="{{'cs.psv.person.profile.aboutMe.header' | hisUi}}" id="aboutMe">
    <div class="infoMessage">
        <span>{{'cs.psv.person.profile.aboutMe.info' | hisUi}}</span>
    </div>
    <div class="clearAndSpace"></div>
    @if (aboutMeObject) {
    <his-plam [showLabelTop]="true">
        <textarea #content rows="10"
          [ngModel]="aboutMeObject.entrytext"
          [hisObject]="aboutMeObject" hisAttribute="entrytext"
          hisDdKey="cs.psv.person.profile.aboutMe"
          class="textareaWidth100">
        </textarea>
    </his-plam>
    }
</p-panel>
}

<div class="clearAndSpace"></div>

@if (!showResearchFields) {
<p-panel header="{{'cs.psv.person.profile.researchField.header' | hisUi}}" id="researchField">
    <div class="clearAndSpace"></div>
    <his-plam [showLabelTop]="true" key="cs.psv.person.profile.researchField.header">
        <ng-container *ngIf="researchFieldsObject">
            <his-editor #content class="tenRowsHeight" 
                [(ngModel)]="researchFieldsObject.entrytext"
                hisDdKey="cs.psv.person.profile.researchFields" 
                [hisObject]="researchFieldsObject"
                hisAttribute="entrytext"
                (translationLanguageChanged)="translationLanguageChanged($event, researchFieldsObject)" 
                toolbar="none">
            </his-editor>
        </ng-container>
    </his-plam>
    <div class="clearAndSpace"></div>
</p-panel>
}

<div class="clearAndSpace"></div>

@if (!showTeachingFields) {
<p-panel header="{{'cs.psv.person.profile.teachingField.header' | hisUi}}" id="teachingField">
    <div class="clearAndSpace"></div>
    <his-plam [showLabelTop]="true" key="cs.psv.person.profile.teachingField.header">
        <ng-container *ngIf="teachingFieldsObject">
            <his-editor #content 
                [(ngModel)]="teachingFieldsObject.entrytext"
                hisDdKey="cs.psv.person.profile.teachingFields" 
                [hisObject]="teachingFieldsObject"
                hisAttribute="entrytext"
                (translationLanguageChanged)="translationLanguageChanged($event, teachingFieldsObject)" 
                toolbar="none">
            </his-editor>
        </ng-container>
    </his-plam>
    <div class="clearAndSpace"></div>
</p-panel>
}